import { FrxTheme, TokenKey, UserKey } from "@/common/constant";
import { CommonStateType } from "@/common/types";

export const getThemePreference: () => CommonStateType["theme"] = () => {
  const themePreference = window.localStorage.getItem(
    FrxTheme
  ) as CommonStateType["theme"];
  document.documentElement.classList.toggle("dark", themePreference === "dark");
  return themePreference || "light";
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setAuthToLocalStorage = (payload: any) => {
  const { token, user } = payload;
  localStorage.setItem(btoa(TokenKey), btoa(token));
  localStorage.setItem(btoa(UserKey), btoa(JSON.stringify(user)));
};

export const getAuthFromLocalStorage = () => {
  const token = localStorage.getItem(btoa(TokenKey)) || "";
  if (token === "") {
    return { auth: false, token: null, user: null };
  }
  let user = null;
  const userKey = localStorage.getItem(btoa(UserKey));
  if (userKey) {
    user = JSON.parse(atob(userKey));
  }
  return { auth: true, token: atob(token), user };
};

export const clearAuthFromLocalStorage = () => {
  localStorage.removeItem(btoa(TokenKey));
  localStorage.removeItem(btoa(UserKey));
};

export const isUserAdmin = () => {
  const { user } = getAuthFromLocalStorage();
  return user?.role === "admin";
};

export const isUserDoctor = () => {
  const { user } = getAuthFromLocalStorage();
  return user?.role === "doctor";
};

export const isUserPatient = () => {
  const { user } = getAuthFromLocalStorage();
  return user?.role === "patient";
};

export const getInitials = (name: string) => {
  return name
    ?.split(" ")
    .slice(0, 2)
    .map((item) => item[0])
    .join("")
    .toUpperCase();
};

export const transformKitStatus = (status: string) => {
  try {
    if (status) {
      return status
        .split("_")
        .map(
          (item) =>
            item.toLowerCase().charAt(0).toUpperCase() +
            item.toLowerCase().slice(1)
        )
        .join(" ");
    } else {
      return status;
    }
  } catch (error) {
    console.error(error);
    return status;
  }
};

export const capitalize = (str: string) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};
